<template>
  <div class="main-menu">
    <h1 class="visually-hidden">Ювелирные калькуляторы онлайн</h1>
    <CalculatorsList/>
  </div>
</template>

<script setup>
// import MetalsRate from './MetalsRate.vue'
import CalculatorsList from './CalculatorsList'




</script>

<style lang="scss" scoped>
.main-menu { width: 100%; }
</style>
